<template>
	<div class="addcollectpay" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="2" class="collabel"><span>单据编号</span></el-col>
			<el-col :span="4"><el-input size="mini" ref="billid" v-model="collectpay.billid" @keyup.native="val => enterinput(val, 'crm_c_id', '')"></el-input></el-col>
			<el-col :span="2" class="collabel"><span>客户名称</span></el-col>
			<el-col :span="4">
				<el-select
					ref="crm_c_id"
					v-model="collectpay.crm_c_cname"
					filterable
					remote
					reserve-keyword
					size="mini"
					placeholder="请输入关键词"
					:remote-method="customerinput"
					@keyup.native="val => enterinput(val, 'p_pkval', 'billid')"
					@change="handleSelect"
					:loading="loading"
				>
					<el-option v-for="item in customerlist" :key="item.cname" :label="item.cname" :value="item.cname"></el-option>
				</el-select>
			</el-col>
			<el-col :span="2" class="collabel"><span>关联单号</span></el-col>
			<el-col :span="4" style="padding-right:10px">
				<el-input size="mini" ref="p_pkval" v-model="collectpay.p_pkval" @keyup.native="val => enterinput(val, 'tablegrid', 'crm_c_id')"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" style="padding-left:15px">
				<tableui
					style="width:99%;"
					ref="tablegridcollectpay"
					v-loading="loading"
					:tableData="limitlist"
					:columns="limitcol"
					:gridheight="gridheight"
					editcell="1"
					:stripe="false"
					@gridhandle="collectpayhandle"
					@autoaddrow="collectpayhandle"
					@setuparrow="setuparrow"
				></tableui>
			</el-col>
		</el-row>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savecollectpay" ref="save">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback" ref="reback">返回</div></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			btndisabled: false,
			windowHeight: window.innerHeight - 120,
			gridheight: window.innerHeight - 300 + 'px',
			type: '', // 1-收款单 0-付款单
			customerlist: [],
			collectpay: {
				billid:'',
				crm_c_id: '', //客户编号
				crm_c_cname: '', //客户名称
				p_pkval: '',
				p_type:''
			},
			loading: false,
			limitcol: [
				{ field: 'p_payitem', title: '收费项目', type: 'select_filter', width: '120', source: [], oldsource: []},
				{ field: 'p_paytype', title: '收费方式', type: 'select_filter', width: '120', source: [], oldsource: []},
				{ field: 'amount', title: '金额', type: 'input', width: '80'},
				{ field: 'u_createtime', title: '操作时间', type: 'time', width: '120' },
				{ field: 'remark', title: '备注', type: 'input', width: '200' },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '120',
					template: [
						{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
						{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
					]
				}
			],
			limitlist: [],
			limitrow: {
				p_type: '',
				p_paytype: '',
				amount: '',
				u_createtime: '',
				remark: ''
			},
			divclass: 'addcollectpay',
			id:''//单据唯一id，修改时用
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/collectpay.scss');
		});
		if (this.urlparam != undefined) {
			if (this.urlparam.type != undefined) 
			{
				this.type = this.urlparam.type;
				this.collectpay.p_type=this.type;
			}
			if(this.urlparam.billid!=undefined) this.collectpay.billid=this.urlparam.billid;
		}
		this.init();
	},
	methods: {
		init() {
			this.limitrow.u_createtime = this.$tool.formatdate();
			var that = this;
			setTimeout(function() {
				that.$refs['crm_c_id'].focus();
			}, 200);
			this.getFeeItem();
			this.GetcollectpayInfo('');
		},
		//生成单据编号
		getBillid(){
			if(this.collectpay.billid=='')//生成一个时间戳
				this.collectpay.billid=new Date().getTime();
		},
		//获取收费项目
		getFeeItem() {
			var that = this;
			this.$apipost.get.dic({ type: '收费项目' }).then(res => {
				var feeitem = res.list;
				//设置列数据源
				var index = -1;
				for (var i = 0; i < that.limitcol.length; i++) {
					if (that.limitcol[i].field == 'p_type') {
						index = i;
						break;
					}
				}
				if (index > -1) {
					that.limitcol[index].source = JSON.parse(JSON.stringify(feeitem));
					that.limitcol[index].oldsource = JSON.parse(JSON.stringify(feeitem));
				}
			});
			this.$apipost.get.dic({ type: '支付方式' }).then(res => {
				var payitem = res.list;
				payitem.splice(0, 1);
				//设置列数据源
				var index = -1;
				for (var i = 0; i < that.limitcol.length; i++) {
					if (that.limitcol[i].field == 'p_paytype') {
						index = i;
						break;
					}
				}
				if (index > -1) {
					that.limitcol[index].source = JSON.parse(JSON.stringify(payitem));
					that.limitcol[index].oldsource = JSON.parse(JSON.stringify(payitem));
				}
			});
			if (that.limitlist.length == 0) that.limitlist.push(JSON.parse(JSON.stringify(that.limitrow)));
		},
		//选择客户联动
		customerinput(val) {
			var that = this;
			var search = {
				searchbox: val,
				c_type: '客户,客户及供应商'
			};
			this.$tool.customerlink(this, search, 'page');
		},
		//文本框回车
		enterinput(event, colnext, colperv) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (colnext != '') {
						if (colnext == 'tablegrid') this.$refs.tablegridcollectpay.setgridfoucs();
						else if (colnext == 'crm_c_id')
							//获取订单信息
							this.GetcollectpayInfo(colnext);
						else this.$refs[colnext].focus();
					}
				} else if (event.keyCode == 37) {
					if (colperv != '') this.$refs[colperv].focus();
				}
			}
		},
		//获取订单详情
		GetcollectpayInfo(colnext) {
			var that = this;
			if (this.collectpay.billid != '') {
				var paraminfo = {
					billid: this.collectpay.billid,
					type: this.type,
					userid: localStorage.getItem('userid')
				};
				this.$tool.loading('正在读取订单', this.divclass);
				//console.log('uoqu账簿',JSON.stringify(paraminfo));
				this.$apipost.get.GetCollectPayInfo({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '0') {
						that.collectpay.billid = '';
						this.$refs['billid'].focus();
						this.$tool.message(res.message, 0);
					} else {
						if(colnext!=''){
							this.$refs[colnext].focus();
						}
						if (res.collectpayinfo != '' && res.collectpayinfo != undefined) {
							that.collectpay = res.collectpayinfo;
							that.id=res.collectpayinfo.id;
						} else {
							var billid = that.collectpay.billid;
							that.collectpay = {
								crm_c_id: '', //客户编号
								crm_c_cname: '', //客户名称
								billid: billid,
								p_pkval: ''
							};
						}
						that.limitlist = [];
						if (res.limitlist != undefined) {
							if (res.limitlist.length > 0) {
								that.limitlist = res.limitlist;
							}
						}
						if (that.limitlist.length == 0) that.limitlist.push(JSON.parse(JSON.stringify(that.limitrow)));
					}
				});
			}
			else{
				this.getBillid();
			}
		},
		//选中提示选项时
		handleSelect(item) {
			var list = this.customerlist.filter(e => {
				return e.cname == item;
			});
			if (list.length > 0) {
				this.collectpay.crm_c_id = list[0].id;
			}
		},
		//保存账单信息
		savecollectpay() {
			var that = this;
			var isgo = true;
			if (this.collectpay.billid == '') {
				this.$tool.message('请填写单据编号', 0);
				isgo = false;
			}
			if (this.type == '1') {
				if (this.collectpay.crm_c_cname == '') {
					this.$tool.message('请填写客户名称', 0);
					isgo = false;
				}
			}
			if (isgo) {
				for (var i = 0; i < this.limitlist.length; i++) {
					if (this.limitlist[i].p_payitem == '' && this.limitlist[i].p_paytype == '' && (this.limitlist[i].amount == '' || this.limitlist[i].amount == '0')) {
						if (i == 0) {
							this.$tool.message('请填写费用明细', 0);
							isgo = false;
							break;
						} else this.limitlist.splice(i, 1);
					} else {
						if (this.limitlist[i].p_payitem == '') {
							this.$tool.message('请填写第' + (i + 1) + '行的收费项目', 0);
							isgo = false;
							break;
						}
						if (this.limitlist[i].p_paytype == '') {
							this.$tool.message('请填写第' + (i + 1) + '行的收费方式', 0);
							isgo = false;
							break;
						}
						if (this.limitlist[i].amount == '' || this.limitlist[i].amount == '0') {
							this.$tool.message('请填写第' + (i + 1) + '行的金额', 0);
							isgo = false;
							break;
						}
					}
				}
			}
			if (isgo) {
				this.$tool.loading('正在保存', this.divclass);
				this.btndisabled = true;
				var paraminfo = {
					id:this.id,
					collectpay: this.collectpay,
					limitlist: this.limitlist,
					userid: localStorage.getItem('userid'),
					u_name: localStorage.getItem('u_name'),
					u_account: localStorage.getItem('u_account'),
					u_company: localStorage.getItem('u_company')
				};
				console.log('保存',JSON.stringify(paraminfo));
				//return false;
				this.$apipost.post.SaveCollectPay({ paraminfo: JSON.stringify(paraminfo) }).then(res => {
					this.$tool.loadingclose();
					that.btndisabled = false;
					if (res.state == '1') {
						this.$tool.message('保存成功', 1);
						setTimeout(function() {
							that.reback();
						}, 1500);
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			}
		},
		//返回
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		//列表操作事件
		collectpayhandle(e) {
			if (e.event == 'addrow') {
				this.limitlist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.limitrow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
		},
		//删除行
		deleteRow(e) {
			this.limitlist.splice(e.index, 1);
			if (this.limitlist.length < 1) {
				this.limitlist.push(JSON.parse(JSON.stringify(this.limitrow)));
			}
		},
		setuparrow() {
			this.enterinput({ keyCode: 37 }, '', 'p_pkval');
		}
	}
};
</script>
